import { IntlError, IntlErrorCode } from 'next-intl'
import { defineRouting } from 'next-intl/routing';
import {  GetRequestConfigParams } from 'next-intl/server'

/**
 * 请求 i18n 翻译文件
 */
const getNextRequestConfig = async (
  i18nRouting: Parameters<typeof defineRouting>[number],
  { requestLocale }: GetRequestConfigParams,
) => {
  // This typically corresponds to the `[locale]` segment
  let locale = await requestLocale

  // Ensure that a valid locale is used
  if (!locale || !i18nRouting.locales.includes(locale)) {
    locale = i18nRouting.defaultLocale
  }

  return {
    locale,
    messages: (await import(`./messages/${locale}.json`)).default,
    onError(error: IntlError) {
      if (error.code === IntlErrorCode.MISSING_MESSAGE) {
        // Missing translations are expected and should only log an error
        console.error('MISSING_MESSAGE ===', error)
      } else {
        // Other errors indicate a bug in the app and should be reported
        // reportToErrorTracking(error)
        console.error('reportToErrorTracking ===', error)
      }
    },
  }
}

export default getNextRequestConfig
